// extracted by mini-css-extract-plugin
export default {"ModeratorInvitationListItem":"bea_a bib_a bib_r bib_j","ModeratorInvitationListItem__left":"bea_b bib_a bib_j","ModeratorInvitationListItem__note":"bea_c bib_fo"};